import f from "./index.es519.js";
function y(t, r) {
  return b(t) || p(t, r) || h(t, r) || g();
}
function g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h(t, r) {
  if (t) {
    if (typeof t == "string") return m(t, r);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(t, r) : void 0;
  }
}
function m(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, e = Array(r); n < r; n++) e[n] = t[n];
  return e;
}
function p(t, r) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var e, o, l, a, u = [], i = !0, c = !1;
    try {
      if (l = (n = n.call(t)).next, r !== 0) for (; !(i = (e = l.call(n)).done) && (u.push(e.value), u.length !== r); i = !0) ;
    } catch (s) {
      c = !0, o = s;
    } finally {
      try {
        if (!i && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return u;
  }
}
function b(t) {
  if (Array.isArray(t)) return t;
}
function d(t) {
  return t.length === 0 ? "" : '<mergeCells count="'.concat(t.length, '">') + t.map(function(r) {
    var n = y(r, 2), e = n[0], o = n[1], l = f(e[1], e[0] + 1) + ":" + f(o[1], o[0] + 1);
    return '<mergeCell ref="'.concat(l, '"/>');
  }).join("") + "</mergeCells>";
}
export {
  d as default
};
//# sourceMappingURL=index.es503.js.map
